export enum ContainerType{
    MAIN = 'main',
    HEADER = 'header'
}